import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HeatmapModule from 'highcharts/modules/heatmap';
import i18n, { t } from 'i18next';

HeatmapModule(Highcharts);

interface Props {
  overThresholdHeatmap: OverThresholdHeatmapProps;
  isPrinting?: boolean;
}

interface OverThresholdHeatmapProps {
  data: number[][];
  threshold: number;
  xCategories: string[];
  yCategories: string[];
}

// 閾値超過率Heatmap生成
export const OverThresholdHeatmapGraph = React.memo(({ overThresholdHeatmap, isPrinting = false }: Props) => {
  const xAxisCategories = overThresholdHeatmap.xCategories ? overThresholdHeatmap.xCategories : [];
  const xAxisMax = overThresholdHeatmap.xCategories ? overThresholdHeatmap.xCategories.length - 1 : 0;

  const option: Highcharts.Options = {
    title: {
      text: '',
    },
    chart: {
      zoomType: 'x',
      height: 30,
      marginLeft: 120,
      marginRight: isPrinting ? 180 : 48,
      marginTop: 0,
      marginBottom: 0,
      shadow: false,
      animation: false,
      backgroundColor: '#FFFFFF',
    },
    xAxis: {
      categories: xAxisCategories,
      min: 0,
      max: xAxisMax,
      tickInterval: 2,
      visible: false,
    },
    yAxis: {
      categories: [`${t('trendValue', '傾向値')} %<br>(${t('thresholdValue', '閾値')} ${overThresholdHeatmap.threshold})`],
      reversed: false,
      gridLineWidth: 0,
      title: { text: '' },
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 'bold',
        },
      },
    },
    colorAxis: {
      min: 0,
      floor: 0,
      max: 100,
      minColor: '#FFEEEE',
      maxColor: '#CC4444',
      labels: {
        format: '{value}%',
      },
    },
    series: [
      {
        type: 'heatmap',
        boostThreshold: 100,
        data: overThresholdHeatmap.data,
        colsize: 1,
        rowsize: 1,
        index: 0,
        turboThreshold: Number.MAX_VALUE,
        dataLabels: {
          enabled: true,
          color: '#000000',
          style: {
            fontSize: '12px',
          },
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<b>{point.value}</b><br/>',
        },
      },
    ],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
    },
  };

  React.useEffect(() => {
    Highcharts.charts.forEach((chart) => {
      if (chart) {
        chart.reflow();
      }
    });
  }, [isPrinting]);

  return <HighchartsReact highcharts={Highcharts} options={option} />;
});
